import React, { useEffect, useState } from "react";
import axios from "axios";

const AdminPlatformCharge = () => {
  const [amount, setAmount] = useState("");
  const [currentCharge, setCurrentCharge] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [message, setMessage] = useState("");

  const API_URL = "https://api.dreamtoday.in/api/admin/platform-charge";

  // 🔹 Fetch current charge
  const fetchCharge = async () => {
    try {
      setFetchLoading(true);
      const res = await axios.get(API_URL);
      setCurrentCharge(res.data.charge);
      setAmount(res.data.charge.amount);
    } catch (err) {
      console.error(err);
      setMessage("Failed to fetch platform charge");
    } finally {
      setFetchLoading(false);
    }
  };

  // 🔹 Update charge
  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const res = await axios.put(API_URL, {
        amount: Number(amount),
      });

      setMessage(res.data.message || "Updated successfully");
      fetchCharge();
    } catch (err) {
      console.error(err);
      setMessage("Update failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCharge();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-blue-100 flex items-center justify-center p-4">
      
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-6">
        
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Platform Charge
        </h2>

        {/* Current Charge */}
        {fetchLoading ? (
          <p className="text-center text-gray-500">Loading...</p>
        ) : currentCharge ? (
          <div className="mb-4 text-center">
            <p className="text-gray-600">Current Charge</p>
            <p className="text-3xl font-bold text-indigo-600">
              {currentCharge.amount}%
            </p>
          </div>
        ) : null}

        {/* Form */}
        <form onSubmit={handleUpdate} className="space-y-4">
          
          <div>
            <label className="block text-gray-700 mb-1">
              Update Amount
            </label>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-400 outline-none"
              placeholder="Enter amount"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-indigo-600 text-white py-2 rounded-lg hover:bg-indigo-700 transition duration-200"
          >
            {loading ? "Updating..." : "Update Charge"}
          </button>
        </form>

        {/* Message */}
        {message && (
          <p className="mt-4 text-center text-sm text-green-600">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default AdminPlatformCharge;